import { FormsModule } from "@angular/forms";

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";




import { UserAuthRoutingModule } from "./user-auth-routing.module";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { UserAuthService } from "./user-auth.service";
// import { StudentRegisterComponent } from './student-register/student-register.component';
// import { CompanyRegisterComponent } from './company-register/company-register.component';
//服务
import { CategoryOptionService } from '../../job/category-option/category-option.service';


@NgModule({
  imports: [
    CommonModule,
    // PictrueUploaderModule,
    FormsModule, 
    // BaiduMapModule,
    HttpClientModule,
    UserAuthRoutingModule, 
    // SelectOptionModule,DateOptionModule,
    // LevelLinkageModule,InputOptionModule
  ],
  declarations: [LoginComponent, RegisterComponent,
    //  StudentRegisterComponent, CompanyRegisterComponent
    ],
  exports: [LoginComponent, RegisterComponent, FormsModule,
    //  StudentRegisterComponent, CompanyRegisterComponent
    ],
  providers: [UserAuthService, CategoryOptionService]
})
export class UserAuthModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/user-auth/user-auth.module.ts